import { createContext, ReactNode, useContext } from 'react'

import useMarketPlaceDetail from 'hooks/marketplace/use-market-place-detail'

interface MarketPlaceContextType {
  isContractManager?: boolean
  contract?: any
  checkContractManager?: () => void
}

const MarketPlaceContext = createContext<MarketPlaceContextType>({
  isContractManager: false,
  contract: null,
  checkContractManager: () => {},
})

interface MarketPlaceContextProps {
  children: ReactNode
}

const MarketPlaceProvider: React.FC<MarketPlaceContextProps> = ({ children }) => {
  const { isContractManager, contract, checkContractManager } = useMarketPlaceDetail()

  return (
    <MarketPlaceContext.Provider
      value={{
        isContractManager,
        contract,
        checkContractManager,
      }}
    >
      {children}
    </MarketPlaceContext.Provider>
  )
}

const useMarketPlaceContext = (): MarketPlaceContextType => {
  const context = useContext(MarketPlaceContext)

  if (context === undefined) {
    throw new Error('Context not available')
  }

  return context
}

export { MarketPlaceProvider, useMarketPlaceContext }
